import { ApplicationRef, ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { AllEconomicDataComponent } from 'IndicatorsApp/ts/features/all-economic-data-module/all-economic-data.component';
import { AllEconomicDataModule } from 'IndicatorsApp/ts/features/all-economic-data-module/all-economic-data.module';
import { ReportLinkComponent } from 'IndicatorsApp/ts/features/report-tooltip-module/report-link.component';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { getLogger } from 'NewAngular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
    constructor(_document, componentFactoryResolver) {
        this._document = _document;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngDoBootstrap(applicationRef) {
        AppModule.bootstrapComponents.forEach((component) => {
            const { selector } = this.componentFactoryResolver.resolveComponentFactory(component);
            const elements = this._document.querySelectorAll(selector);
            elements.forEach((element) => {
                applicationRef.bootstrap(component, element);
            });
        });
    }
}
AppModule.bootstrapComponents = [AllEconomicDataComponent, TopBarNavComponent, ReportLinkComponent];
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AllEconomicDataModule,
        BrowserModule,
        ConfigModule,
        NavigationModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
